module.exports = __webpack_public_path__ + "img/logotyp_bez_przedzialu_lat.22debd71.jpg";